function getDataDiff(dataInicio, dataFim) {

    dataInicio = new Date(dataInicio);
    dataFim = new Date(dataFim)

    dataFim.setDate(dataFim.getDate()+1)

    const diffTime = Math.abs(dataFim - dataInicio);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    var diffTotalMeses = (dataFim.getFullYear() - dataInicio.getFullYear()) * 12 + (dataFim.getMonth() - dataInicio.getMonth());

    diffTotalMeses = isNaN(diffTotalMeses) ? 0 : diffTotalMeses

    return { diffDays, diffTime, diffTotalMeses }

}

function verificaPercentualAnual(diasLetivos, limiteMeses, iter) {

    let diasLetivosSlice = diasLetivos.slice(iter, limiteMeses)
    let totalDiasLetivos = diasLetivosSlice.reduce((acc, atual) => acc + atual, 0)

    let novoPercentual = diasLetivos.map((dias, index) => {
        if(index >= iter && index < limiteMeses) return dias === 0 ? 0 : dias / totalDiasLetivos
        else return 0
    })

    let percentualAnoLetivo = novoPercentual
    return percentualAnoLetivo
}

export default { getDataDiff, verificaPercentualAnual }
